export interface CarDetailResponse {
  data: CarDetail;
}

export interface CarDetail {
  id: string;
  name: string;
  brand: CarBrand | null;
  modelYear: number;
  ogpPhotoUrl: string;
  photos: Photo[];
  movieUrl: string | null;
  copy: string;
  price: string;
  previousPrice: string;
  totalPrice: string;
  useSpecifiedPrice: boolean;
  estimateLowerPrice: string;
  estimateUpperPrice: string;
  currentBidPrice: string;
  descriptionHtml: string;
  area: string;
  firstYearMonth: string;
  displacement: string;
  distance: string;
  manualTransmission: string;
  steeringWheel: string;
  color: string;
  chassisNumber: string;
  engineNumber: string;
  vehicleInspection: string;
  inTransaction: boolean;
  sold: boolean;
  new: boolean;
}

export interface CarBrand {
  id: string;
  name: string;
}

export interface Photo {
  url: string;
  caption: string;
}

export interface CarListResponse {
  pagination: CarPagination;
  data: CarListItem[];
}

export interface CarPagination {
  totalCount: number;
  perPage: number;
  currentPage: number;
  currentPageFrom: number;
  currentPageTo: number;
  nextPage?: number;
  prevPage?: number;
}

export interface CarCollection {
  items: CarListItem[];
  pagination: CarPagination;
}

export interface CarListItem {
  id: string;
  name: string;
  modelYear: number;
  mainPhotoUrl: string;
  copy: string;
  price: string;
  previousPrice: string;
  useSpecifiedPrice: boolean;
  estimateLowerPrice: string;
  estimateUpperPrice: string;
  currentBidPrice: string;
  inTransaction: boolean;
  sold: boolean;
  new: boolean;
}

export function getOGPImageUrl(car: CarDetail): string {
  return car.ogpPhotoUrl ? car.ogpPhotoUrl : car.photos[0].url;
}
